<ng-container *ngIf="loadingContent">
  <h2 id="modal-title" class="sr-only">{{specialWizard?.orderableSpecial?.label}}</h2>
  <fts-loading-indicator [topPadding]="true"></fts-loading-indicator>
</ng-container>
<ng-container #content></ng-container>
